import { CSSProperties, ReactNode } from 'react'
import './style.css'

type PageComponentProps = {
    center?: boolean;
    style?: CSSProperties;
    children?: ReactNode;
}

export const PageComponent = ({center = true, children, style}: PageComponentProps) => {
    const positionStyle = center ? {alignItems: 'center', justifyContent: 'center'} : {};

    return (
        <div className='page' style={{...positionStyle, ...style}}>
            {children}
        </div>
    )
}

